export default [

    {
        path: '',
        name: 'banco-de-midias',
        redirect: { name: 'banco-de-midias-home' },
    },

    {
        path: 'home',
        name: 'banco-de-midias-home',
        component: () => import('@/aplicacao/modulos/banco-de-midias/_Home'),
        meta: { autenticacao: true, permissao: 'ROLE_BANCO_DE_MIDIAS' },
    },

    {
        path: 'produtos',
        name: 'banco-de-midias-produtos',
        component: () => import('@/aplicacao/modulos/banco-de-midias/BancoDeProdutos'),
        meta: { autenticacao: true, permissao: 'ROLE_BANCO_DE_MIDIAS_PRODUTOS' },
    },

    {
        path: 'marcas',
        name: 'banco-de-midias-marcas',
        component: () => import('@/aplicacao/modulos/banco-de-midias/BancoDeMarcas'),
        meta: { autenticacao: true, permissao: 'ROLE_BANCO_DE_MIDIAS_MARCAS' },
    },

    {
        path: 'clientes',
        name: 'banco-de-midias-clientes',
        component: () => import('@/aplicacao/modulos/banco-de-midias/BancoDeClientes'),
        meta: { autenticacao: true, permissao: 'ROLE_BANCO_DE_MIDIAS_CLIENTES' },
    },

    {
        path: ':slug',
        name: 'banco-de-midias-personalizadas',
        component: () => import('@/aplicacao/modulos/banco-de-midias/Personalizadas'),
        meta: { autenticacao: true, permissao: 'ROLE_BANCO_DE_MIDIAS_PERSONALIZADAS' },
    },

]
